/* eslint-disable */
import React, { useState } from "react";
import {
	Card, CardBody, Label, FormGroup, Row, Input, CardHeader,
	CardFooter, Col, Button, Container, Form, FormFeedback
} from "reactstrap";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import SweetAlert from "react-bootstrap-sweetalert";
import MobileHeader1 from "components/Headers/MobileHeader1";
import SimpleHeaderMobile from "components/Headers/SimpleHeaderMobile"

export default function EditPasswordProfileMobile() {
	const [alert, setAlert] = useState(null);
	const token = localStorage.token;
	const history = useHistory();
	const username = localStorage.username;

	const [password, setPassword] = useState("");
	const [confirmpassword, setConfirmPassword] = useState("");
	const [passworderror, setPasswordError] = useState(null);

	const validateForm = () => {
		if (password === confirmpassword) {
			setQuestionAlert();
			return false;
		} else {
			setPasswordError("invalid");
			return true;
		}
	};

	const handleformvalidasi = (e) => {
		e.preventDefault();
		if (!validateForm()) {
			setQuestionAlert();
		}
	};

	const UpdatePasswordProfile = () => {
		const headers = { Authorization: `Bearer ${token}` };
		const data = {
			username,
			password: confirmpassword,
		};

		axios
			.post(`${process.env.REACT_APP_API_BASE_URL}/users/reset-password`, data, { headers })
			.then((response) => {
				setSuccessAlert(response.data.message);
				setTimeout(() => history.push("/mobile/profile"), 1000);
			})
			.catch((error) => {
				setGagalAlert(error.response.data.message);
			});
	};

	const setSuccessAlert = (msg) => {
		setAlert(
			<SweetAlert success showConfirm confirmBtnText="Ok" title={msg} onCancel={hideAlert} onConfirm={hideAlert} />
		);
	};

	const setGagalAlert = (msg) => {
		setAlert(
			<SweetAlert danger showConfirm confirmBtnText="Ok" title={msg} onCancel={hideAlert} onConfirm={hideAlert} />
		);
	};

	const setQuestionAlert = () => {
		setAlert(
			<SweetAlert
				warning
				showCancel
				confirmBtnText="Lanjutkan"
				confirmBtnBsStyle="danger"
				title="Apakah Kamu Yakin?"
				onConfirm={UpdatePasswordProfile}
				onCancel={hideAlert}
				focusCancelBtn
			/>
		);
	};

	const hideAlert = () => setAlert(null);

	return (
		<>
			{alert}
			{/* <MobileHeader1 name="New Password" parentName="Master" /> */}
			<SimpleHeaderMobile to="/mobile/profile" />
			<Container className="mt--6" fluid>
				<Row>
					<Col xs="12">
						<Card className="bg-secondary shadow">
							<CardHeader className="bg-white border-0 d-flex justify-content-between align-items-center">
								{/* <Link className="btn btn-link" to="/mobile/profile">
									<i className="fa fa-arrow-circle-left fa-2x" />
								</Link> */}
								<h4 className="mb-0">Ganti Password</h4>
								<div style={{ width: "30px" }} /> {/* Spacer */}
							</CardHeader>

							<Form onSubmit={handleformvalidasi}>
								<CardBody>
									<FormGroup>
										<Label className="form-control-label">Password Baru</Label>
										<Input
											type="password"
											placeholder="Password"
											value={password}
											onChange={(e) => setPassword(e.target.value)}
											className="form-control-alternative"
											autoComplete="off"
										/>
									</FormGroup>

									<FormGroup>
										<Label className="form-control-label">Konfirmasi Password</Label>
										<Input
											type="password"
											placeholder="Konfirmasi Password"
											value={confirmpassword}
											onChange={(e) => {
												setConfirmPassword(e.target.value);
												if (e.target.value !== password) {
													setPasswordError("invalid");
												} else {
													setPasswordError(null);
												}
											}}
											className="form-control-alternative"
											autoComplete="off"
											invalid={passworderror === "invalid"}
										/>
										<FormFeedback>Password Tidak Sama</FormFeedback>
									</FormGroup>
								</CardBody>

								<CardFooter className="text-center">
									<Button color="danger" type="submit" block>
										Simpan
									</Button>
								</CardFooter>
							</Form>
						</Card>
					</Col>
				</Row>
			</Container>
		</>
	);
}
